import { render, staticRenderFns } from "./FormClientComponent.vue?vue&type=template&id=a4fb9aa0&"
import script from "./FormClientComponent.vue?vue&type=script&lang=js&"
export * from "./FormClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports